import './style.css'
const HomePage = () => <div className='landing__section'><h1>Welcome In Our Stores  Collections !</h1></div>;
export default HomePage;
